export const statusList = [
  { id: "draft", name: "Draft" },
  { id: "unposted", name: "Unposted" },
];
